import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Button, Typography } from '@mui/material';
import { ProgressButton } from '@vayufp/coast-components';
import { useFormik } from 'formik';
import React, { useState, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';

import { setSelectedChannel } from '../../../../app/reducers';
import { phoneSchema, PreliminaryInfo } from '../../../../domain/person';
import { OtpRequest } from '../../../../domain/qualification';
import { ErrorMessage } from '../../../../general/components/error-message';
import { CelticBankDisclaimer } from '../../../../general/components/footers/celtic-bank-disclaimer/CelticBankDisclaimer';
import { FormikPhoneField } from '../../../../general/inputs/formik-phone-field';
import { RootState } from '../../../../store';
import { savePreliminaryInfo } from '../../../../store/reducers/preliminaryInfo';
import { removePhoneFormatting } from '../../../../utils';
import { DocumentLinks } from '../../../legal-consent/components/document-links';
import { privacyPolicySelector } from '../../../legal-consent/selectors/legal-document-selectors';
import { requestOtp } from '../../reducer/session';

const selector = (state: RootState) => {
  const {
    preliminaryInfo: { info },
    session: { error, loading },
  } = state;
  return {
    loading,
    error,
    personalDetails: info,
    privacyPolicy: privacyPolicySelector(state),
  };
};

const validationSchemaVerify = yup.object({ phone: phoneSchema });

const GetStartedVerifyForm: FC = () => {
  const dispatch = useDispatch();
  const { personalDetails, error, loading, privacyPolicy } = useSelector(selector);
  const [channel, setChannel] = useState<OtpRequest['channel']>('sms');

  const formik = useFormik({
    initialValues: {
      ...personalDetails,
    },
    validationSchema: validationSchemaVerify,
    onSubmit: (values: PreliminaryInfo) => {
      const phone = removePhoneFormatting(values.phone);
      dispatch(requestOtp({ phone, channel }));
      dispatch(setSelectedChannel(channel));
      dispatch(savePreliminaryInfo({ ...values, phone }));
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <ErrorMessage error={error} />
      <FormikPhoneField formik={formik} fullWidth id="phone" label="Phone" name="phone" />

      <Typography variant="caption" align="center" component="div" mt={4}>
        By selecting an option below, I agree to receive a code via either text or phone call. Message and data rates
        may apply. See <DocumentLinks documents={[privacyPolicy]} />.
      </Typography>

      <ProgressButton
        onClick={() => {
          setChannel('sms');
          formik.handleSubmit();
        }}
        color="primary"
        variant="contained"
        progress={loading}
        size="large"
        sx={{ mt: 3 }}
        fullWidth
      >
        Text My Code
      </ProgressButton>
      <Button
        onClick={() => {
          setChannel('call');
          formik.handleSubmit();
        }}
        variant="text"
        startIcon={<PhoneIcon />}
        fullWidth
        size="large"
        sx={{ mt: 2 }}
      >
        Call Me Instead
      </Button>
      <Box mt={3}>
        <CelticBankDisclaimer />
      </Box>
    </form>
  );
};

export { GetStartedVerifyForm };
